import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef,Output, EventEmitter,  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { Subscription } from 'rxjs';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { EducationService } from '../../services/education.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-education-view',
	templateUrl: './education-view.component.html',
	styleUrls: ['./education-view.component.scss']
})
export class EducationViewComponent implements OnDestroy {
@ViewChild('eventRef') eventRef: ElementRef;
@Output() selectClass = new EventEmitter < any > ();

results: any = [];
eventlist: any = [];
color: any = 'blue';
educationAccess: boolean = false;
private userSub: Subscription;

constructor(private educationService: EducationService, private globalSearchService: GlobalSearchService, private route: ActivatedRoute, private modalService: NgbModal) {
	this.color = this.globalSearchService.getColor();
	this.userSub = this.globalSearchService.user.subscribe((result) => {
		const hadAccess = this.educationAccess;
		this.educationAccess = !!(result && result.user && result.user.education_access);
		if (this.educationAccess && !hadAccess) {
			this.getEvents();
		}
	});
}

ngOnInit(){
}

ngOnDestroy(): void {
	this.userSub?.unsubscribe();
}
	
getEvents(){
	this.educationService.getPortalEvents().subscribe((a) => {
		this.results = a;
		if (this.results) {
			this.results.forEach((evt) => {
				if(!evt.expired){
					this.eventlist.push(evt);
				}
			});
				
		}
			
	});
}
	
showEvents() {
	this.modalService.open(this.eventRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

	}, (reason) => {
				
	});
		
}
	
addClass(item: any){
	const data = { stockid: item };
	this.selectClass.emit(data);
}
}
